module.exports = __webpack_public_path__ + "static/media/lang-ru.b0a178fc.svg";